import { createContext } from 'react';

import { EnrichedCommand } from 'utils/commands';

export type KeyboardKeybindingsTableRowContextValue = {
  readonly enrichedCommand: EnrichedCommand;
};

export const KeyboardKeybindingsTableRowContext =
  createContext<KeyboardKeybindingsTableRowContextValue>(undefined!);
